import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { SuggestedEnrichment } from '../types/suggested-opportunities.types';

/**
 * Sprint 5b.1.6 C.1 — Badges inline pour les contraintes fortes détectées par l'IA.
 *
 * Affichés UNIQUEMENT si l'enrichissement a détecté la contrainte. Pour les AO
 * sans enrichissement (en attente du job BullMQ), rien ne s'affiche → card standard.
 *
 * Les badges sont informatifs : si l'AO arrive jusqu'ici c'est que le tenant est
 * éligible (sinon le filtre dur l'a déjà éliminé côté backend, cf. amendement C.3).
 */

interface ConstraintBadgesProps {
  enrichment: SuggestedEnrichment;
  className?: string;
}

export function ConstraintBadges({ enrichment, className }: ConstraintBadgesProps) {
  const badges: { label: string; tone: 'amber' | 'rose' | 'sky' }[] = [];

  if (enrichment.reservedToEss) {
    badges.push({ label: 'Réservé ESS', tone: 'amber' });
  }
  if (enrichment.reservedToSocieteMission) {
    badges.push({ label: 'Réservé société à mission', tone: 'amber' });
  }
  if (enrichment.reservedToPme) {
    badges.push({ label: 'Réservé PME', tone: 'sky' });
  }
  if (enrichment.requiresDefenseClearance) {
    badges.push({
      label: `Habilitation ${enrichment.requiresDefenseClearance === 'CONFIDENTIEL' ? 'Confidentiel' : 'Secret'} Défense`,
      tone: 'rose',
    });
  }

  if (badges.length === 0) return null;

  return (
    <div className={cn('flex flex-wrap gap-1.5', className)}>
      {badges.map((b) => (
        <Badge
          key={b.label}
          className={cn(
            'text-xs font-normal',
            b.tone === 'amber' && 'bg-amber-100 text-amber-800 hover:bg-amber-100',
            b.tone === 'rose' && 'bg-rose-100 text-rose-800 hover:bg-rose-100',
            b.tone === 'sky' && 'bg-sky-100 text-sky-800 hover:bg-sky-100',
          )}
        >
          {b.label}
        </Badge>
      ))}
    </div>
  );
}
